import { useContext, useEffect, useState } from 'preact/hooks';
import { SessionContext } from '../app.jsx';
import { get, post } from '../api.js';
import { Link, navigate } from '../router.js';
import { Field } from '../ui/Field.jsx';
import { fmtRange } from '../../lib/dates.js';

const PARTS = [['back', 'Vratilo se'], ['damaged', 'Oštećeno'], ['missing', 'Nestalo']];
const sum = (s) => PARTS.reduce((n, [k]) => n + (/^\d+$/.test(s[k].trim()) ? Number(s[k]) : NaN), 0);

// SC-004 Popis opreme: each take split into back / damaged / missing; saving frees the guide.
export function Inventory({ params }) {
  const id = Number(params.id);
  const { user } = useContext(SessionContext);
  const [dep, setDep] = useState(null);
  const [split, setSplit] = useState({}); // takeId → { back, damaged, missing } as typed
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    get(`/departures/${id}`).then((d) => {
      setDep(d);
      const own = d.takes.filter((k) => k.guide.id === user.id);
      setSplit(Object.fromEntries(own.map((k) => [k.id, { back: String(k.qty), damaged: '0', missing: '0' }])));
    }, (e) => setError(e.message));
  }, [id]);

  if (!dep) return error ? <p class="alert" role="alert">{error}</p> : null;
  const { departure: d, mine, released } = dep;
  const own = dep.takes.filter((k) => k.guide.id === user.id && split[k.id]);
  const head = (
    <>
      <h1>Popis opreme</h1>
      <p class="sub">{`${d.tour.name}, ${fmtRange(d.start_date, d.end_date)}`}</p>
    </>
  );
  if (!mine) {
    return (
      <>
        {head}
        <p class="empty">{released ? 'Popis je sačuvan.' : 'Prvo se prijavi na ovu turu.'} <Link href={`/ture/${id}`}>Na turu</Link></p>
      </>
    );
  }

  const off = own.some((k) => sum(split[k.id]) !== k.qty);
  const set = (takeId, key, value) => setSplit((s) => ({ ...s, [takeId]: { ...s[takeId], [key]: value } }));

  const save = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await post(`/departures/${id}/inventory`, {
        items: own.map((k) => ({ takeId: k.id, ...Object.fromEntries(PARTS.map(([key]) => [key, Number(split[k.id][key])])) })),
      });
      navigate(`/ture/${id}`);
      return;
    } catch (err) {
      setError(err.message);
    }
    setBusy(false);
  };

  return (
    <>
      {head}
      <form class="inventory" onSubmit={save}>
        {own.length === 0 && <p class="empty">Nisi upisao opremu za ovu turu. Sačuvaj popis da budeš slobodan.</p>}
        {own.map((k) => (
          <div key={k.id} class="split">
            <fieldset class="card">
              <legend>{`${k.item.name} — ${k.qty}`}</legend>
              <div class="split-fields">
                {PARTS.map(([key, label]) => (
                  <Field key={key} label={label}>
                    <input type="number" inputmode="numeric" min="0" max={k.qty} step="1" required
                      value={split[k.id][key]} onInput={(e) => set(k.id, key, e.currentTarget.value)} />
                  </Field>
                ))}
              </div>
            </fieldset>
            {sum(split[k.id]) !== k.qty && <p class="alert" role="alert">{`Zbir mora biti ${k.qty}.`}</p>}
          </div>
        ))}
        {error && <p class="alert" role="alert">{error}</p>}
        <div class="actions">
          <button class="btn" disabled={busy || off}>Sačuvaj popis</button>
        </div>
      </form>
    </>
  );
}
